import RenderPipeline from "./renderpipeline";
import ShaderService from "../../../lib/services/shader/shader_service";
import ResourceService from "../../../lib/services/resource/resourceservice";
import BaseObject from "../scene/baseobject";
import Transform from "./transform";
import Camera from "../scene/camera";

export default class RenderObject extends BaseObject {
  transform: Transform;
  layer:number = 0; //only supporting 0 & 1 for now
  constructor(key: string) {
    super(key);
    this.transform = new Transform();
  }

  async build(
    device: GPUDevice,
    format: GPUTextureFormat,
    shader_service: ShaderService,
    resource_service: ResourceService
  ): Promise<void> {}

  /**
   * CPU-only state advance. Called from scene_service.tick before render
   * begins. Default no-op; subclasses override if they have CPU state.
   */
  tick(delta_time: number): void {}

  /**
   * Encode compute work for this frame into the shared compute pass.
   * Runs before the render pass begins, in the same command encoder as
   * the rest of the frame. Default no-op; subclasses override to dispatch
   * compute shaders that produce data the render pass will read.
   *
   * Implementations should expect that data produced here will not be
   * visible to this same frame's render pass without an explicit barrier
   * (which WebGPU provides automatically between encoder passes). For
   * cross-frame producer/consumer patterns using slot pools, render
   * reads the most recently published slot which is typically last frame's
   * compute output.
   */
  compute(device: GPUDevice, pass: GPUComputePassEncoder, encoder:GPUCommandEncoder ): void {}

  /**
   * Per-frame data prep before the render pass starts. Default no-op.
   */
  prepare(device: GPUDevice, camera: Camera): void {}

  /**
   * Record draw calls into the render pass. Default no-op.
   */
  draw(pass: GPURenderPassEncoder): void {}

  /**
   * Record any readback copies (copyBufferToBuffer into MAP_READ buffers)
   * into the shared command encoder before submit. Default no-op.
   * Subclasses that need GPU-to-CPU data use this hook.
   */
  readback_encode(device: GPUDevice, encoder: GPUCommandEncoder): void {}

  /**
   * Release any leases held during prepare/draw. Called after the
   * command buffer has been submitted to the queue. Default no-op.
   */
  finish_draw(): void {}

  /**
   * Drive any asynchronous readback state machines (mapAsync, etc).
   * Called after submit and after finish_draw. Default no-op.
   * Subclasses with active mapAsync work poll here to advance state
   * and publish ready CPU slots.
   */
  readback_poll(device: GPUDevice): void {}
}